var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 20,
    fill: "#2E3238"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2929 25.2929C29.6834 24.9024 30.3166 24.9024 30.7071 25.2929L36.7071 31.2929C37.0976 31.6834 37.0976 32.3166 36.7071 32.7071L30.7071 38.7071C30.3166 39.0976 29.6834 39.0976 29.2929 38.7071C28.9024 38.3166 28.9024 37.6834 29.2929 37.2929L34.5858 32L29.2929 26.7071C28.9024 26.3166 28.9024 25.6834 29.2929 25.2929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionBtn);
export default __webpack_public_path__ + "static/media/ActionBtn.b314fd9c27928f686bb0385230e7fc73.svg";
export { ForwardRef as ReactComponent };